/* eslint-disable */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const LineTruncate = styled.div`
  display: table;
  table-layout: fixed;
  width: ${props => props.width || "100%"};
  white-space: nowrap;
  text-align: ${props => props.textAlign || "left"};

  > * {
    display: table-cell;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

LineTruncate.propTypes = {
  width: PropTypes.string,
  textAlign: PropTypes.string
};

export default LineTruncate;
